// actions creator
export const ACTIONS_CREATOR_CONSTRUCTOR = Symbol('AbstractActionsCreatorConstructor');

// annotator
export const ANNOTATOR = Symbol('Annotator');

// api
export const API_CONSTRUCTOR = Symbol('AbstractApiConstructor');

// enhancer
export const ENHANCER = Symbol('Enhancer');

// lifecycle manager
export const LIFECYCLE_MANAGER_CONSTRUCTOR = Symbol('LifecycleManagerConstructor');
